import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import { mod } from '~/client/helpers/add-bem-modifiers';
import type { Tagline as Props } from './tagline.types';
import { taglineThemes } from './tagline.types';

const Tagline: React.FC<React.PropsWithChildren<Props>> & {
  themes: typeof taglineThemes;
} = ({ onDark, words, theme = taglineThemes.Included, italic = true }) => (
  <div className="tagline">
    {words.map((word, index) => (
      <div
        className={mod('tagline__word', theme, {
          last: index === words.length - 1 && theme === taglineThemes.Included,
          'on-dark': onDark,
        })}
        key={word}
      >
        <Text size={Text.sizes.basic} theme="headline" italic={italic}>
          {word}
        </Text>
      </div>
    ))}
  </div>
);

Tagline.themes = taglineThemes;

export default Tagline;
